import React, { useEffect, useRef, useState } from "react";
import { Image } from "antd";
import {
  InventoryProductRequest,
  getUOM,
  uploadImage,
  uploadImageUrl,
} from "../../API/API Functions/ProductRequest_API";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { InputBox } from "../CustomWidgets/InputBox";
import SelectBox from "../CustomWidgets/SelectBox";
import UploadMediaonly from "../CustomWidgets/upload-imageonly";
import { toast } from "react-toastify";
import LoadingSpinner from "../CustomWidgets/Laoding";
import { useNavigate } from "react-router-dom";
import BarcodeScanner from "react-barcode-reader";
import { detectWebDeviceType } from "../../utils";
import UOMInputDropdown from "../CustomWidgets/UOMInputDropdown";
import AlphaNumericKeyboardModal from "./AlphaNumericKeyboardModal";
import i18n from "../../i18n";

const RequestProductModal = ({isOpen, updateScreen, fetchedProduct, onCancel }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const [UOM, setUOM] = useState([]);
  const [isUOMLoaded, setIsUOMLoaded] = useState(false);
  const [base64Images, setBase64Images] = useState([]); // Store multiple images
  const [isFileValid, setIsFileValid] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [loading, setLoading] = useState(false);
  const deviceType = detectWebDeviceType();
  const [keyboardVisible, setKeyboardVisible] = useState(false);
  const [focusedField, setFocusedField] = useState(null);
  const [keyboardMode, setKeyboardMode] = useState("alphanumeric");
  // const productNameRef = useRef(null);
  const inputRef = useRef(null);
  

  // useEffect(() => {
  //     if (inputRef.current && fetchedProduct) {
  //       inputRef.current.focus();
  //     }
  //   }, [fetchedProduct]);


  useEffect(() => {
    // Simulate a click on the product name input when the modal opens
    if (inputRef.current) {
      inputRef.current.click();
    }
  }, []); 


  const handleCustomKeyPress = (key) => {
    if (key === "SPACE") key = " ";
    else if (key === "DEL") {
      setFormValues((prev) => ({
        ...prev,
        [focusedField]: prev[focusedField]?.slice(0, -1),
      }));
      return;
    }

    setFormValues((prev) => ({
      ...prev,
      [focusedField]: (prev[focusedField] || "") + key,
    }));
  };

  const [formValues, setFormValues] = useState({
    name: fetchedProduct?.product_description_english
      ? fetchedProduct?.product_description_english
      : "",
    barcode: fetchedProduct?.gtin
      ? fetchedProduct?.gtin
      : fetchedProduct?.barcode
      ? fetchedProduct?.barcode
      : "",
    product_uom: "",
    costprice: "",
    saleprice: "",
    quantity: "1",
    image_url: "",
    product_code: "",
    is_gs1: fetchedProduct?.gtin ? true : false,
  });

  useEffect(() => {
    if (base64Images.length > 0 && isFileValid === false) {
      setBase64Images([]);
      setFormValues((prev) => ({ ...prev, image_url: "" }));
    }
  }, [isFileValid, base64Images]);

  const get_UOM = async () => {
    const res = await getUOM();
    if (res?.result?.[0].status === "UOM List")
      setUOM(res?.result?.[0]?.uom_list);
    setIsUOMLoaded(true);
  };

  useEffect(() => {
    if (UOM?.length <= 0) {
      get_UOM();
    }
  }, [UOM]);

  useEffect(() => {
    if (isUOMLoaded) {
      const uomId = UOM.find((uom) => uom.uom_name === "Units")?.uom_id;
      if (uomId) {
        setFormValues((prev) => ({
          ...prev,
          product_uom: uomId,
        }));
      }
    }
  }, [isUOMLoaded, fetchedProduct, UOM]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageUpload = (images) => {
    setBase64Images(images);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formValues.name === "") {
      toast.error(t("Product name is required."));
      return;
    }

    if (formValues.quantity === "" || formValues.quantity === 0) {
      toast.error(t("Quantity is required."));
      return;
    }

    if (formValues.product_uom === "") {
      toast.error(t("Please Select Product UOM"));
      return;
    }

    // if (formValues.costprice === "") {
    //   toast.error(t("Cost Price is required"));
    //   return;
    // }

    if (formValues.saleprice === "") {
      toast.error(t("Sale Price is required"));
      return;
    }

    if (Number(formValues.costprice) > Number(formValues.saleprice)) {
      toast.error(t("Sale price cannot be less than cost price."));
      return;
    }

    if (formValues.product_code.length < 7 && formValues.product_code) {
      toast.error(t("Product code should not be less than 7 digits."));
      return;
    }

    setProcessing(true);
    setLoading(true);

    try {
      const costPrice = formValues?.costprice || 0;
      const salePrice = formValues?.saleprice || 0;

      const response = await InventoryProductRequest(
        user_id,
        formValues,
        costPrice,
        salePrice
      );

      if (response?.result[0]?.status_code === 200) {
        const productId = response.result[0].product_id;

        const imageUrls = [];
        if (base64Images.length > 0) {
          for (let i = 0; i < base64Images.length; i++) {
            const uploadedImageUrl = await uploadImage(
              productId,
              base64Images[i],
              i
            );
            if (uploadedImageUrl) {
              imageUrls.push(uploadedImageUrl);
            }
          }
        } else {
          // If no images are uploaded, use the default image URL
          imageUrls.push(
            "https://assets.myginne.com/assets/retailer_profile_img/no-image.png"
          );
        }

        const primaryImageUrl = imageUrls[0];
        const secondaryImageUrls = imageUrls.slice(1);
        const isImageUrlUploaded = await uploadImageUrl(
          productId,
          primaryImageUrl,
          secondaryImageUrls
        );

        if (isImageUrlUploaded) {
          toast.success(t("Product request submitted successfully"));
          setFormValues({
            name: "",
            barcode: "",
            product_uom: "",
            costprice: "",
            saleprice: "",
            quantity: "",
            image_url: "",
            product_code: "",
            is_gs1: false,
          });
          setBase64Images([]);
          updateScreen(productId);
          setLoading(false);
        } else {
          toast.error("Failed to upload image URLs.");
        }
      } else if (response?.result[0]?.status_code === 400) {
        toast.error("Product already exists.");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error submitting product request:", error);
      toast.error("Failed to submit product request. Please try again.");
    } finally {
      setProcessing(false);
      setLoading(false);
    }
  };

  // const handleCancel = () => {
  //   navigate("/session"); // Navigate to the /session route
  // };

  return (
    <>
      {loading && <LoadingSpinner />}

      <div className="fixed top-0 left-0 flex flex-col z-30 w-full h-full  items-center backdrop-blur-md drop-shadow-sm  justify-center mx-auto">
        <div className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-40"></div>
        <section
          className={` flex flex-col text-lg font-semibold leading-6 bg-white rounded-[25px] text-zinc-800 max-md:px-5 z-50 ${
            deviceType === "tablet" ? "fixed left-20" : "relative "
          }`}
          style={{
            width: deviceType === "tablet" ? "45%" : "1700px",
          }}
        >
          <button
            type="button"
            onClick={onCancel}
            className={`absolute top-4 ${
              i18n.language === "ar" ? "left-3" : "right-3"
            } text-zinc-800 bg-transparent`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-8 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <div className="h-16 bg-[#C9ECF7] rounded-t-2xl flex items-center">
            <p className="ms-10 font-semibold text-xl">
              {t("Product not found in the inventory – Kindly add it")}
            </p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col md:flex-row flex-1 bg-white border rounded-b-2xl pt-0 p-6">
               <div className={`m-2 w-full p-4 text-xl
              ${
                deviceType === "tablet" ? "" : "md:w-2/4 "
              }`}
              >
                <InputBox
                  ref={inputRef} 
                  name="name"
                  label={t("Product Name")}
                  placeholder={t("Enter Product Name")}
                  readOnly={deviceType === "tablet"}
                  onFocus={() => {
                    if (deviceType === "tablet") {
                      setKeyboardMode("alphanumeric");

                      setFocusedField("name");
                      setKeyboardVisible(true);
                    }
                  }}
                  focused={focusedField === "name"}
                  onChange={handleChange}
                  value={formValues.name}
                />

                <InputBox
                  type={deviceType === "tablet" ? "text" : "number"}
                  label={t("Barcode")}
                  name="barcode"
                  placeholder={t("Enter Barcode")}
                  onChange={(event) => {
                    const { value } = event.target;
                    if (/^\d*$/.test(value)) {
                      setFormValues((prev) => ({ ...prev, barcode: value }));
                    }
                  }}
                  inputMode="none"
                  readOnly={deviceType === "tablet"}
                  onFocus={() => {
                    if (deviceType === "tablet") {
                      setKeyboardMode("numeric");

                      setFocusedField("barcode");
                      setKeyboardVisible(true);
                    }
                  }}
                  focused={focusedField === "barcode"}
                  value={formValues.barcode}
                />

                <BarcodeScanner
                  onScan={(data) => {
                    setFormValues((prev) => ({ ...prev, barcode: data }));
                  }}
                  onError={(err) => {
                    console.error(err);
                  }}
                  facingMode="environment"
                  className="absolute inset-y-0 right-0 me-4 pointer-events-none cursor-pointer z-10"
                />

                <div
                  className={`flex flex-col md:flex-row mt-2 ${
                    deviceType === "tablet" ? "" : "gap-5"
                  }`}
                >
                  {/* <InputBox
                    type="text"
                    name="quantity" 
                    label={t("Quantity")}
                    placeholder={t("Enter Quantity")}
                    inputMode="none"
                    readOnly={deviceType === "tablet"}
                    onFocus={() => {
                      if (deviceType === "tablet") {
                        setKeyboardMode("numeric");

                        setFocusedField("quantity");
                        setKeyboardVisible(true);
                      }
                    }}
                    focused={focusedField === "quantity"}
                    onChange={(event) => {
                      const { value } = event.target;

                      const selectedUom = UOM.find(
                        (uom) =>
                          uom.uom_name === "Units" &&
                          uom.uom_id === formValues.product_uom
                      );
                      if (
                        (selectedUom?.uom_name !== "Units" &&
                          /^\d*\.?\d{0,2}$/.test(value)) || // Allow decimals for non-units
                        (selectedUom?.uom_name === "Units" &&
                          /^\d{0,5}$/.test(value)) // Only whole numbers for units
                      ) {
                        if (!/[^\d.]/.test(value) && !/(--)/.test(value)) {
                          setFormValues((prev) => ({
                            ...prev,
                            quantity: value,
                          }));
                        }
                      }
                    }}
                    value={formValues.quantity}
                  /> */}

                  {/* {deviceType === "pc" && (
                    <>
                      <SelectBox
                        name="product_uom"
                        label={t("Product UOM")}
                        defaultValue=""
                        onChange={handleChange}
                        value={formValues.product_uom}
                        options={[
                          { value: "", label: t("Select"), disabled: true },
                          ...UOM?.map((item) => ({
                            value: item.uom_id,
                            label: t(item.uom_name),
                          })),
                        ]}
                      />

                      {formValues.product_uom &&
                        UOM.find(
                          (uom) =>
                            (uom?.uom_name === "KG" ||
                              uom.uom_name === "Liter") &&
                            uom?.uom_id === formValues?.product_uom
                        ) && (
                          <InputBox
                            type="number"
                            name="product_code"
                            label={t("Product Code")}
                            placeholder={t("Enter Product Code")}
                            onChange={(event) => {
                              const { value } = event.target;
                              if (/^\d{0,7}$/.test(value)) {
                                setFormValues((prev) => ({
                                  ...prev,
                                  product_code: value,
                                }));
                              }
                            }}
                            value={formValues.product_code}
                          />
                        )}
                    </>
                  )} */}
                </div>

                {deviceType === "tablet" && (
                  <>
                    {/* React Native WebView-compatible layout */}
                    <div className="mb-3 mt-4">
                      <label className="py-2 text-md  text-black font-medium">
                        {t("Product UOM")}
                      </label>
                      <UOMInputDropdown
                        uomOptions={UOM}
                        selectedValue={formValues.product_uom}
                        onChange={(value) =>
                          setFormValues((prev) => ({
                            ...prev,
                            product_uom: value,
                          }))
                        }
                      />
                    </div>

                    {formValues.product_uom &&
                      UOM.find(
                        (uom) =>
                          (uom?.uom_name === "KG" ||
                            uom?.uom_name === "Liter" ||  uom?.uom_name === "Meter") &&
                          uom?.uom_id === formValues?.product_uom
                      ) && (
                        <InputBox
                          type={deviceType === "tablet" ? "text" : "number"}
                          name="product_code"
                          label={t("Product Code")}
                          placeholder={t("Enter Product Code")}
                          inputMode="none"
                          readOnly={deviceType === "tablet"}
                          onFocus={() => {
                            if (deviceType === "tablet") {
                              setKeyboardMode("numeric");

                              setFocusedField("product_code");
                              setKeyboardVisible(true);
                            }
                          }}
                          focused={focusedField === "product_code"}
                          onChange={(event) => {
                            const { value } = event.target;
                            if (/^\d{0,7}$/.test(value)) {
                              setFormValues((prev) => ({
                                ...prev,
                                product_code: value,
                              }));
                            }
                          }}
                          value={formValues.product_code}
                        />
                      )}
                  </>
                )}

                <div className="flex flex-col md:flex-row mt-2 gap-y-4 md:gap-x-4">
                  {/* <div  className={`mb-4 md:mb-0 md:mr-4 ${
    deviceType !== "tablet" ? "me-3" : ""
  }`}>
                    <InputBox
                      type={deviceType === "tablet" ? "text" : "number"}
                      name="costprice"
                      label={t("Cost Price")}
                      placeholder={t("Enter Cost Price")}
                      inputMode="none"
                      readOnly={deviceType === "tablet"}
                      onFocus={() => {
                        if (deviceType === "tablet") {
                          setKeyboardMode("numeric");

                          setFocusedField("costprice");
                          setKeyboardVisible(true);
                        }
                      }}
                      focused={focusedField === "costprice"}
                      onChange={(event) => {
                        const { value } = event.target;
                        if (
                          value === "" ||
                          /^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(value)
                        ) {
                          if (!/[^\d.]/.test(value) && !/(--)/.test(value)) {
                            setFormValues((prev) => ({
                              ...prev,
                              costprice: value,
                            }));
                          }
                        }
                      }}
                      value={formValues.costprice}
                    />
                  </div> */}

                  <div>
                    <InputBox
                      type={deviceType === "tablet" ? "text" : "number"}
                      label={t("Sale Price")}
                      name="saleprice"
                      placeholder={t("Enter Sale Price")}
                      inputMode="none"
                      readOnly={deviceType === "tablet"}
                      onFocus={() => {
                        if (deviceType === "tablet") {
                          setKeyboardMode("numeric");

                          setFocusedField("saleprice");
                          setKeyboardVisible(true);
                        }
                      }}
                      focused={focusedField === "saleprice"}
                      onChange={(event) => {
                        const { value } = event.target;

                        if (
                          value === "" ||
                          /^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(value)
                        ) {
                          if (!/[^\d.]/.test(value) && !/(--)/.test(value)) {
                            setFormValues((prev) => ({
                              ...prev,
                              saleprice: value,
                            }));
                          }
                        }
                      }}
                      value={formValues.saleprice}
                    />
                  </div>
                </div>

                {/* {deviceType === "pc" && ( */}
                <div className="flex items-center mt-8 ">
                  <button
                    type="submit" // Changed to type="submit"
                    disabled={processing}
                    className="w-56 h-12 mt-2 bg-blue-900 text-white text-l me-3 font-semibold rounded-lg flex items-center justify-center gap-2"
                  >
                    {processing ? "Processing..." : t("Save")}
                  </button>

                    <button
                      type="button" // Changed to type="submit"
                      disabled={processing}
                      onClick={onCancel}
                      className="w-56 h-12 mt-2 bg-white text-blue-900 border-blue-900 border text-l font-semibold rounded-lg flex items-center justify-center gap-2"
                    >
                      {t("Cancel")}
                    </button>
                  </div>
                {/* )} */}
              </div>
              {deviceType === "pc" && (
                <div className=" relative m-2 w-full md:w-2/4 p-4">
                  <div className="grid grid-cols-2 gap-4">
                    {base64Images.map((image, index) => (
                      <div
                        key={index}
                        className={`relative overflow-hidden border-2 rounded-lg ${
                          deviceType === "tablet"
                            ? "w-[140px] h-[100px]"
                            : "h-32"
                        }`}
                      >
                        <Image
                          src={image}
                          alt={`Uploaded ${index}`}
                          className="w-full h-32 object-contain rounded-lg"
                        />
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            const newImages = [...base64Images];
                            newImages.splice(index, 1);
                            setBase64Images(newImages);
                          }}
                          className="absolute top-1 right-1 bg-red-500 text-white font-semibold rounded-lg w-8 h-8 flex items-center justify-center"
                        >
                          X
                        </button>
                      </div>
                    ))}
                  </div>

                  {base64Images.length < 6 && (
                    <UploadMediaonly
                      foldername={"store_image"}
                      onfileAdd={"Productrequest"}
                      setBase64Images={handleImageUpload}
                      multiple={true}
                      setIsFileValid={setIsFileValid}
                    />
                  )}
                </div>
              )}
            </div>
          </form>
        </section>
        {deviceType === "tablet" && keyboardVisible && (
          <AlphaNumericKeyboardModal
            onClose={() => setKeyboardVisible(false)}
            onKeyPress={handleCustomKeyPress}
            mode={keyboardMode}
            width="42%"
            maxWidth="42%"
            maxHeight="44%"
          />
        )}
      </div>
    </>
  );
};

export default RequestProductModal;
